import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TabNames, c1, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-tab-chat-with-admin-icon-component",
  templateUrl: "./tab-chat-with-admin-icon-component.component.html",
  styleUrls: ["./tab-chat-with-admin-icon-component.component.scss"],
})
export class TabChatWithAdminIconComponentComponent
  implements OnInit, OnDestroy
{
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private builderService: BuilderService
  ) {}

  @Input() tab_id: string;
  tab: Tab;
  mode: string;

  // default values
  imageLg: string;
  imageSm: string;
  image: string;
  icon: string;
  icon_ios: string;
  title: string;
  roundedBottom = true;
  offCanvasSubscription: any;
  currentTabSubscription: any;
  enableChatWithAdmin = false;
  textColor = "#ffffff";
  stickyBgColor = "#ff2121";
  offcanvasColors = offcanvasColors;
  newTab = false;
  floating_button = {
    bg_color: null,
    size: "m",
    type: "talk_admin",
  };
  iconSize = {
    l: "Large",
    m: "Medium",
    s: "Small",
  };
  selectedIconSize = "m";
  off_canvas_key: string = "tab";
  selectedIconBg;
  colors;
  isAndroid: boolean;
  data: any;
  tabList = {};
  sortedTabList = [];
  current_tab_id;
  component_id: string;
  field_id: string;
  ngOnInit() {
    this.field_id='tab_chat_with_admin_icon';
    this.currentTabSubscription = this.mdw.currentTabContainer$.subscribe(
      (data) => {
        if (
          data &&
          (data["cat"] == "home" || data["cat"] == "side") &&
          data.target === "tabSetting" &&
          data.current_tab &&
          this.tab_id &&
          data.current_tab.id == this.tab_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedTabList = this.data["sortedTabList"];
          this.tabList = this.data["tabList"];
          this.tab = data["tabList"][this.tab_id];
          this.tabFunction();
        }
      }
    );

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "tab" &&
          data.tab &&
          data.tab.id == this.tab_id
        ) {
          this.TabIntialize(data);
          this.tabFunction();
        }
      }
    );
  }

  TabIntialize(data) {
    this.data = data.data;
    if (data.tab.id == this.tab_id) {
      this.tab = { ...data.tab };
      this.component_id = this.tab.id + this.field_id;
    }
    this.sortedTabList = this.data["sortedTabList"];
    this.tabList = this.data["tabList"];
    this.mode = localStorage.getItem("mode");
  }

  tabFunction() {
    if (this.tab) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      if (this.tab.floating_button && this.tab.floating_button.length > 0) {
        this.enableChatWithAdmin = true;
        this.floating_button = this.tab.floating_button[0];
        this.selectedIconSize = this.tab.floating_button[0].size;
        this.selectedIconBg = this.tab.floating_button[0].bg_color ? this.tab.floating_button[0].bg_color : '#000000';
        // if (this.selectedIconBg === null) {
        //   const itemColor = this.indexDBService.getItem("item", "color");
        //   itemColor.onsuccess = (event) => {
        //     this.colors = itemColor.result;
        //     this.selectedIconBg = this.colors.primary;
        //   };
        // }
      }
    }
  }

  colorIconChange(event) {
    const floating_button_list = [];
    const floating_button = this.floating_button;
    floating_button.bg_color = event;
    floating_button_list.push(floating_button);
    this.tab.floating_button = floating_button_list;
    this.updateTabData();
  }

  changeIconSize(val) {
    const floating_button_list = [];
    const floating_button = this.floating_button;
    floating_button.size = val;
    floating_button_list.push(floating_button);
    this.tab.floating_button = floating_button_list;
    this.updateTabData();
  }

  updateTabData() {
    //*must be there in all Tabs
    this.tabList[this.tab_id] = this.tab;

    let index = this.sortedTabList.findIndex((e) => e.id == this.tab_id);
    this.sortedTabList[index] = { ...this.tab };
    this.data["sortedTabList"] = this.sortedTabList;
    this.data["TabList"] = this.tabList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["current_tab"] = this.tab;
    this.data['target'] ='tabSetting';
    this.data["component_id"] = this.component_id;



    this.mdw._currentTabContainer.next(this.data);
    this.mdw.changeTab({ tab: this.tab }, this.mode, false);
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentTabSubscription) {
      this.currentTabSubscription.unsubscribe();
    }
  }
}
